﻿import { createContext } from 'react';

import arLocalCurrency from 'cldr-numbers-full/main/ar/currencies.json';
import bgLocalCurrency from 'cldr-numbers-full/main/bg/currencies.json';
import deLocalCurrency from 'cldr-numbers-full/main/de/currencies.json';
import elLocalCurrency from 'cldr-numbers-full/main/el/currencies.json';
import esLocalCurrency from 'cldr-numbers-full/main/es/currencies.json';
import frLocalCurrency from 'cldr-numbers-full/main/fr/currencies.json';
import itLocalCurrency from 'cldr-numbers-full/main/it/currencies.json';
import jaLocalCurrency from 'cldr-numbers-full/main/ja/currencies.json';
import koLocalCurrency from 'cldr-numbers-full/main/ko/currencies.json';
import nlLocalCurrency from 'cldr-numbers-full/main/nl/currencies.json';
import plLocalCurrency from 'cldr-numbers-full/main/pl/currencies.json';
import ptLocalCurrency from 'cldr-numbers-full/main/pt/currencies.json';
import roLocalCurrency from 'cldr-numbers-full/main/ro/currencies.json';
import ruLocalCurrency from 'cldr-numbers-full/main/ru/currencies.json';
import svLocalCurrency from 'cldr-numbers-full/main/sv/currencies.json';
import thLocalCurrency from 'cldr-numbers-full/main/th/currencies.json';
import trLocalCurrency from 'cldr-numbers-full/main/tr/currencies.json';
import ukLocalCurrency from 'cldr-numbers-full/main/uk/currencies.json';
import viLocalCurrency from 'cldr-numbers-full/main/vi/currencies.json';
import zhLocalCurrency from 'cldr-numbers-full/main/zh/currencies.json';
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
import arCaGregorian from 'cldr-dates-full/main/ar/ca-gregorian.json';
import bgCaGregorian from 'cldr-dates-full/main/bg/ca-gregorian.json';
import deCaGregorian from 'cldr-dates-full/main/de/ca-gregorian.json';
import elCaGregorian from 'cldr-dates-full/main/el/ca-gregorian.json';
import esCaGregorian from 'cldr-dates-full/main/es/ca-gregorian.json';
import frCaGregorian from 'cldr-dates-full/main/fr/ca-gregorian.json';
import itCaGregorian from 'cldr-dates-full/main/it/ca-gregorian.json';
import jaCaGregorian from 'cldr-dates-full/main/ja/ca-gregorian.json';
import koCaGregorian from 'cldr-dates-full/main/ko/ca-gregorian.json';
import nlCaGregorian from 'cldr-dates-full/main/nl/ca-gregorian.json';
import plCaGregorian from 'cldr-dates-full/main/pl/ca-gregorian.json';
import ptCaGregorian from 'cldr-dates-full/main/pt/ca-gregorian.json';
import roCaGregorian from 'cldr-dates-full/main/ro/ca-gregorian.json';
import ruCaGregorian from 'cldr-dates-full/main/ru/ca-gregorian.json';
import svCaGregorian from 'cldr-dates-full/main/sv/ca-gregorian.json';
import thCaGregorian from 'cldr-dates-full/main/th/ca-gregorian.json';
import trCaGregorian from 'cldr-dates-full/main/tr/ca-gregorian.json';
import ukCaGregorian from 'cldr-dates-full/main/uk/ca-gregorian.json';
import viCaGregorian from 'cldr-dates-full/main/vi/ca-gregorian.json';
import zhCaGregorian from 'cldr-dates-full/main/zh/ca-gregorian.json';
import currencyData from 'cldr-core/supplemental/currencyData.json';
import arDateFields from 'cldr-dates-full/main/ar/dateFields.json';
import bgDateFields from 'cldr-dates-full/main/bg/dateFields.json';
import deDateFields from 'cldr-dates-full/main/de/dateFields.json';
import elDateFields from 'cldr-dates-full/main/el/dateFields.json';
import esDateFields from 'cldr-dates-full/main/es/dateFields.json';
import frDateFields from 'cldr-dates-full/main/fr/dateFields.json';
import itDateFields from 'cldr-dates-full/main/it/dateFields.json';
import jaDateFields from 'cldr-dates-full/main/ja/dateFields.json';
import koDateFields from 'cldr-dates-full/main/ko/dateFields.json';
import nlDateFields from 'cldr-dates-full/main/nl/dateFields.json';
import plDateFields from 'cldr-dates-full/main/pl/dateFields.json';
import ptDateFields from 'cldr-dates-full/main/pt/dateFields.json';
import roDateFields from 'cldr-dates-full/main/ro/dateFields.json';
import ruDateFields from 'cldr-dates-full/main/ru/dateFields.json';
import svDateFields from 'cldr-dates-full/main/sv/dateFields.json';
import thDateFields from 'cldr-dates-full/main/th/dateFields.json';
import trDateFields from 'cldr-dates-full/main/tr/dateFields.json';
import ukDateFields from 'cldr-dates-full/main/uk/dateFields.json';
import viDateFields from 'cldr-dates-full/main/vi/dateFields.json';
import zhDateFields from 'cldr-dates-full/main/zh/dateFields.json';
import { load, loadMessages } from '@progress/kendo-react-intl';
import arNumbers from 'cldr-numbers-full/main/ar/numbers.json'; // ar-SA
import bgNumbers from 'cldr-numbers-full/main/bg/numbers.json'; //bg-BG
import deNumbers from 'cldr-numbers-full/main/de/numbers.json'; //de-DE
import elNumbers from 'cldr-numbers-full/main/el/numbers.json'; //el-GR
import esNumbers from 'cldr-numbers-full/main/es/numbers.json'; //es-MX
import frNumbers from 'cldr-numbers-full/main/fr/numbers.json'; //fr-FR
import itNumbers from 'cldr-numbers-full/main/it/numbers.json'; //it-IT
import jaNumbers from 'cldr-numbers-full/main/ja/numbers.json'; //ja-JP
import koNumbers from 'cldr-numbers-full/main/ko/numbers.json'; //ko-KR
import nlNumbers from 'cldr-numbers-full/main/nl/numbers.json'; //nl-NL
import plNumbers from 'cldr-numbers-full/main/pl/numbers.json'; //pl-PL
import ptNumbers from 'cldr-numbers-full/main/pt/numbers.json'; //pt-BR
import roNumbers from 'cldr-numbers-full/main/ro/numbers.json'; //ro-RO
import ruNumbers from 'cldr-numbers-full/main/ru/numbers.json'; //ru-RU
import svNumbers from 'cldr-numbers-full/main/sv/numbers.json'; //sv-SE
import thNumbers from 'cldr-numbers-full/main/th/numbers.json'; //th-TH
import trNumbers from 'cldr-numbers-full/main/tr/numbers.json'; //tr-TR
import ukNumbers from 'cldr-numbers-full/main/uk/numbers.json'; //uk-UA
import viNumbers from 'cldr-numbers-full/main/vi/numbers.json'; //vi-VN
import zhNumbers from 'cldr-numbers-full/main/zh/numbers.json'; //zh-CN / zh-TW
import weekData from 'cldr-core/supplemental/weekData.json';
import { useIntl } from 'react-intl';

type KendoIntlProps = {
    children: any;
}

const KendoIntlContext = createContext([]);

export const KendoIntlProvider = (props: KendoIntlProps) => {

    const { children } = props;

    const { formatMessage, locale } = useIntl();

    const messages = {
        'calendar': {
            'today': formatMessage({ id: 'today.211f62df', defaultMessage: 'Today' })
        },
        'datepicker': {
            'toggleCalendar': formatMessage({ id: 'toggle_calendar.478163ee', defaultMessage: 'Toggle Calendar' })
        },
        'datetimepicker': {
            'cancel': formatMessage({ id: 'cancel.89a86adc', defaultMessage: 'Cancel' }),
            'date': formatMessage({ id: 'date.bd62e879', defaultMessage: 'Date', description: 'Formulario' }),
            'set': formatMessage({ id: 'set.da60d773', defaultMessage: 'Set' }),
            'time': formatMessage({ id: 'time.446a3218', defaultMessage: 'Time' }),
            'toggleDateTimeSelector': formatMessage({ id: 'toggle_date_time_selector.ac4c9360', defaultMessage: 'Toggle date-time selector' })
        },
        'dropdowns': {
            'clear': formatMessage({ id: 'clear.88d43eb1', defaultMessage: 'Clear' }),
            'nodata': formatMessage({ id: 'no_data_found.78dcb977', defaultMessage: 'No Data Found.' })
        },
        'pager': {
            'firstPage': formatMessage({ id: 'go_to_the_first_page.56e1e096', defaultMessage: 'Go to the first page' }),
            'itemsPerPage': formatMessage({ id: 'items_per_page.6a53cd98', defaultMessage: 'items per page' }),
            'lastPage': formatMessage({ id: 'go_to_the_last_page.b80effd2', defaultMessage: 'Go to the last page' }),
            'nextPage': formatMessage({ id: 'go_to_the_next_page.262577d5', defaultMessage: 'Go to the next page' }),
            'of': formatMessage({ id: 'of.ca18018b', defaultMessage: 'of', description: 'Grid view bar' }),
            'page': formatMessage({ id: 'page.5f3e36fd', defaultMessage: 'Page', description: 'Grid view bar' }),
            'previousPage': formatMessage({ id: 'go_to_the_previous_page.a1b10386', defaultMessage: 'Go to the previous page' })
        },
        'sortable': {
            'noData': formatMessage({ id: 'no_data.42f7c5d3', defaultMessage: 'No Data' })
        },
        'upload': {
            'cancel': formatMessage({ id: 'cancel.89a86adc', defaultMessage: 'Cancel' }),
            'clearSelectedFiles': formatMessage({ id: 'clear.88d43eb1', defaultMessage: 'Clear' }),
            'dropFilesHere': formatMessage({ id: 'drop_files_here_to_upload.52b979ae', defaultMessage: 'Drop files here to upload' }),
            'files': formatMessage({ id: 'files.a2df60d0', defaultMessage: 'files' }),
            'headerStatusUploaded': formatMessage({ id: 'done.88826883', defaultMessage: 'Done' }),
            'headerStatusUploading': formatMessage({ id: 'uploading.ebe3e681', defaultMessage: 'Uploading...' }),
            'invalidFileExtension': formatMessage({ id: 'file_type_not_allowed.2519a09c', defaultMessage: 'File type not allowed.' }),
            'invalidFiles': formatMessage({ id: 'invalid_files_please_check_file_upload_r.ca65adfb', defaultMessage: 'Invalid file(s). Please check file upload requirements.' }),
            'invalidMaxFileSize': formatMessage({ id: 'file_size_too_large.3d115067', defaultMessage: 'File size too large.' }),
            'invalidMinFileSize': formatMessage({ id: 'file_size_too_small.f109f748', defaultMessage: 'File size too small.' }),
            'remove': formatMessage({ id: 'remove.d34ac1e7', defaultMessage: 'Remove' }),
            'retry': formatMessage({ id: 'retry.225ca180', defaultMessage: 'Retry' }),
            'select': formatMessage({ id: 'select_files.28c4f08d', defaultMessage: 'Select files...' }),
            'total': formatMessage({ id: 'total.9c3dfe80', defaultMessage: 'Total' }),
            'uploadSelectedFiles': formatMessage({ id: 'upload.5e546db7', defaultMessage: 'Upload' })
        }
    };

    load(
        likelySubtags,
        currencyData,
        weekData,
        arNumbers,
        arLocalCurrency,
        arCaGregorian,
        arDateFields,
        bgNumbers,
        bgLocalCurrency,
        bgCaGregorian,
        bgDateFields,
        deNumbers,
        deLocalCurrency,
        deCaGregorian,
        deDateFields,
        elNumbers,
        elLocalCurrency,
        elCaGregorian,
        elDateFields,
        esNumbers,
        esLocalCurrency,
        esCaGregorian,
        esDateFields,
        frNumbers,
        frLocalCurrency,
        frCaGregorian,
        frDateFields,
        itNumbers,
        itLocalCurrency,
        itCaGregorian,
        itDateFields,
        jaNumbers,
        jaLocalCurrency,
        jaCaGregorian,
        jaDateFields,
        koNumbers,
        koLocalCurrency,
        koCaGregorian,
        koDateFields,
        nlNumbers,
        nlLocalCurrency,
        nlCaGregorian,
        nlDateFields,
        plNumbers,
        plLocalCurrency,
        plCaGregorian,
        plDateFields,
        ptNumbers,
        ptLocalCurrency,
        ptCaGregorian,
        ptDateFields,
        roNumbers,
        roLocalCurrency,
        roCaGregorian,
        roDateFields,
        ruNumbers,
        ruLocalCurrency,
        ruCaGregorian,
        ruDateFields,
        svNumbers,
        svLocalCurrency,
        svCaGregorian,
        svDateFields,
        thNumbers,
        thLocalCurrency,
        thCaGregorian,
        thDateFields,
        trNumbers,
        trLocalCurrency,
        trCaGregorian,
        trDateFields,
        ukNumbers,
        ukLocalCurrency,
        ukCaGregorian,
        ukDateFields,
        viNumbers,
        viLocalCurrency,
        viCaGregorian,
        viDateFields,
        zhNumbers,
        zhLocalCurrency,
        zhCaGregorian,
        zhDateFields
    );

    loadMessages(messages, locale);

    return (
        <KendoIntlContext.Provider value={[]}>
            {children}
        </KendoIntlContext.Provider>
    );

};